import React from 'react'
import { Link } from 'react-router-dom'
import LayoutContainer from '../shared/LayoutContainer'
import { Row, Col } from 'react-flexbox-grid'
import Text from '../shared/Text'

import styles from './UpcomingEvent.module.css'

const UpcomingEvent = ({ link, description }) => {
  return (
    <LayoutContainer className={styles.upcomingEvent}>
      <Text>Nächster Termin:</Text>
      <Link className={styles.link} to={link} dangerouslySetInnerHTML={{ __html: description }} />
    </LayoutContainer>
  )
}

export default UpcomingEvent



// WEBPACK FOOTER //
// ./src/components/header/UpcomingEvent.js